import { CardSvg } from '@/play/cardSvg'

/** Home card art for Thirsty (an SVG sketch of the page; no text). */
export function ThirstyCardArt() {
  return (
    <CardSvg bg="#f3f6f8">
      <path d="M20 170 L 70 120 H 290 L 300 170 Z" fill="#dfe6ea" />
      <circle cx="140" cy="132" r="18" fill="#ff5fa2" />
      <circle cx="190" cy="140" r="14" fill="#3fb8ff" />
      <circle cx="226" cy="126" r="10" fill="#ffd60a" />
    </CardSvg>
  )
}
